<template>
  <div class="operation-info">
    <el-row>
      <el-col :span="6">
        <el-avatar
          icon="el-icon-user-solid"
          style="width: 70px; height: 70px; font-size: 70px"
        ></el-avatar>
      </el-col>
      <el-col :span="18">
        <el-row>
          <el-col :span="24" class="user-name">{{ operator.username }}</el-col>
          <el-col :span="24" class="role-name">
            <template v-if="operator.roles">
              <el-tag
                v-for="(role, index) in operator.roles"
                :key="index"
                :type="getRoleType(role)"
                effect="dark"
                >{{ role.nameZh }}</el-tag
              >
              <el-tag
                :type="operator.enabled === true ? 'success' : 'danger'"
                disable-transitions
                >{{ operator.enabled === true ? "启用" : "禁用" }}
              </el-tag>

              <el-tag
                :type="operator.caaccount  ? 'success' : 'danger'"
                disable-transitions
                >{{ operator.caaccount ? "已认证CA" : "未认证CA" }}
              </el-tag>

            </template>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">姓名:</el-col>
      <el-col :span="16">{{ operator.name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">办公电话:</el-col>
      <el-col :span="16">{{ operator.officetel }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">手机:</el-col>
      <el-col :span="16">{{ operator.mobile }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="8">所属机构:</el-col>
      <el-col :span="16">{{ operator.organization.name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          v-if="operator && operator.editable === true"
          type="primary"
          size="small"
          plain
          icon="el-icon-edit"
          title="编辑"
          @click="handleEdit()"
        >
        </el-button>

        <el-button
          v-if="operator && operator.editable === true"
          type="danger"
          size="small"
          plain
          icon="el-icon-delete"
          title="删除"
          @click.prevent="handleDelete()"
        >
        </el-button>

        <el-button
          type="success"
          size="small"
          plain
          icon="el-icon-upload"
          title="同步到CA"
          @click.prevent="handleToCA()"
        >
        </el-button>

        <el-button
          type="warning"
          size="small"
          plain
          icon="el-icon-key"
          title="重置密码"
          @click.prevent="handleResetPassword()"
        >
        </el-button
      ></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "OperatorInfo",
  props: { operator: Object },
  Emit: ["edit", "delete", "reset-pass"],
  data() {
    return {};
  },
  methods: {
    getRoleType(role) {
      let type = "";
      switch (role.nameZh) {
        case "超级管理员":
          type = "danger";
          break;
        case "局管理员":
          type = "";
          break;
        case "现管单位操作员":
          type = "success";
          break;
        case "街道工作者":
          type = "warning";
          break;
        default:
          type = "info";
      }

      return type;
    },

    handleEdit() {
      this.$emit("edit", this.operator);
    },
    handleDelete() {
      this.$emit("delete", this.operator);
    },
    handleToCA(){
      this.$emit("update-ca", this.operator);
    },
    handleResetPassword() {
      this.$emit("reset-pass", this.operator);
    },
  },
};
</script>

<style lang="scss">
.operation-info {
  width: 23.75rem;
  height: 15rem;
  box-sizing: border-box;
  padding: 15px;
  text-align: left;
  background-color: white;
  border: 1px solid #33333321;
  border-radius: 10px;
  margin: 0.625rem;
  .el-row {
    margin-bottom: 0.3rem;
  }

  .user-name {
    font-size: xx-large;
  }

  .role-name {
    .el-tag {
      margin-right: 10px;
    }
  }
}
</style>
